module.exports = __webpack_public_path__ + "templates-59e97cd7/template-5-09bf74ea0fcee26b48ae7375e6454061.jpg";